// extracted by mini-css-extract-plugin
module.exports = {"AppsList":"apps-list_AppsList__abJPX","Search":"apps-list_Search__Wyfm0","List":"apps-list_List__dmzpe","AppListItem":"apps-list_AppListItem__Dnfs7","Meta":"apps-list_Meta__mzC6q"};